import { SelectHTMLAttributes, useId } from "react";
import styles from "./Select.module.scss";
import Label from "../Label/Label";
import { ReactComponent as CaretDownIcon } from "../../../assets/icons/ui/caret-down.svg";

export interface NumericalOption {
  label: string;
  value: number;
}

export interface Option {
  label: string;
  value: string | number;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: (Option | NumericalOption)[];
  error?: string;
  className?: string;
}

const Select: React.FC<SelectProps> = ({ label, name, options, error, className, ...props }) => {
  const id = useId();

  return (
    <div className={`${styles.field} ${className ?? ""}`}>
      {label && <Label htmlFor={id}>{label}</Label>}

      <div className={styles.selectWrapper}>
        <select
          id={id}
          name={name}
          className={`${styles.select} ${error ? styles.error : ""}`}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <CaretDownIcon className={styles.icon} />
      </div>

      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default Select;
